module.exports = __webpack_public_path__ + "img/zcfg.8859b582.png";